<template>
  <el-dialog
    :visible.sync="isShow"
    width="900px"
    top="9vh"
    :title="isEdit ? '编辑年度训练计划及总结' : '添加年度训练计划及总结'"
    :close-on-click-modal="false"
    custom-class="yioks_alert"
  >
    <el-form
      ref="planInfo"
      :model="planInfo"

      label-width="135px"
      class="demo-ruleForm"
    >
      <vue-scroll :ops="ops">
        <el-row>
          <el-col :span="20">
            <el-form-item
              label="选择球队"
              prop="squadUuidForCoach"
              :rules="[requiredItem('此项'),true]"
            >
              <el-select
                v-model.trim="planInfo.squadUuidForCoach"
                style="width: 100%"
                no-data-text="暂时没有球队，请前往球队管理添加球队"
                :placeholder="$t('teamPlaceholder')"
                @change="changeSquadForCoach(planInfo.squadUuidForCoach)"
                :disabled="isEdit"
              >
                <el-option
                  v-for="item in selectsquadList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.key"
                  :disabled="item.squadDissolve"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="20">
            <el-form-item label="年份" prop="trainYear" :rules="[requiredItem('此项'),true]">
            <el-date-picker
              value-format="yyyy"
              type="year"
              v-model="planInfo.trainYear"
              placeholder="请选择年份"
              style="width:415px"
            >
            </el-date-picker>
          </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="22">
            <el-form-item label="全年训练基本任务" prop="yearTrainingTask" :rules="[requiredItem('此项')]">
              <el-input
                v-model.trim="planInfo.yearTrainingTask"
                type ="textarea"
                placeholder="请输入全年训练基本任务"
                :rows="4"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="22">
            <el-form-item label="训练与比赛目标" prop="trainAndMatchTarget" :rules="[requiredItem('此项')]">
              <el-input
                v-model.trim="planInfo.trainAndMatchTarget"
                type ="textarea"
                placeholder="请输入训练与比赛目标"
                :rows="4"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>


        <el-row>
          <el-col :span="22">
            <el-form-item label="训练指导思想" prop="trainIdeology" :rules="[requiredItem('此项')]">
              <el-input
                v-model.trim="planInfo.trainIdeology"
                type ="textarea"
                placeholder="请输入训练指导思想"
                :rows="4"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>


        <el-row>
          <el-col :span="22">
            <el-form-item label="训练阶段划分" prop="trainingStageDivision" :rules="[requiredItem('此项')]">
              <el-input
                v-model.trim="planInfo.trainingStageDivision"
                type ="textarea"
                placeholder="请输入训练阶段划分"
                :rows="4"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="22">
            <el-form-item label="训练负荷安排" prop="trainingArrangement" :rules="[requiredItem('此项')]">
              <el-input
                v-model.trim="planInfo.trainingArrangement"
                type ="textarea"
                placeholder="请输入训练负荷安排"
                :rows="4"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="22">
            <el-form-item label="训练基本手段" prop="trainMeans" :rules="[requiredItem('此项')]">
              <el-input
                v-model.trim="planInfo.trainMeans"
                type ="textarea"
                placeholder="请输入训练基本手段"
                :rows="4"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="22">
            <el-form-item label="身体测试及综合考核安排" prop="testArrangement" :rules="[requiredItem('此项')]">
              <el-input
                v-model.trim="planInfo.testArrangement"
                type ="textarea"
                placeholder="请输入身体测试及综合考核安排"
                :rows="4"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="22">
            <el-form-item label="实施训练计划的具体措施" prop="trainImplement" :rules="[requiredItem('此项')]">
              <el-input
                v-model.trim="planInfo.trainImplement"
                type ="textarea"
                placeholder="请输入实施训练计划的具体措施"
                :rows="4"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="22">
            <el-form-item label="可能遇到的问题及困难等" prop="problemsAndDifficulties" :rules="[requiredItem('此项')]">
              <el-input
                v-model.trim="planInfo.problemsAndDifficulties"
                type ="textarea"
                placeholder="请输入可能遇到的问题及困难等"
                :rows="4"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="22">
            <el-form-item label="年度训练总结（后期补充）">
              <el-input
                v-model.trim="planInfo.summaryYear"
                type ="textarea"
                placeholder="请输入全年训练计划的实施情况（突出重点球员执行情况），目标任务完成情况，训练比赛过程中的经验体会，分析存在的缺点与不足，提出下一年度努力目标及实现目标的方法措施。"
                :rows="4"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

      </vue-scroll>
    </el-form>
    <div class="dialog_btn_wrap">
      <el-button
        type="primary"
        :loading="addBtnLoading"
        @click="addPlanAccount"
      >确定</el-button>
      <el-button type="danger" style="margin-left: 20px" @click="isShow = false"
      >取消</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import plan from "@/api/plan";
import squad from "@/api/squad";
//import rulesMixin from "@/utils/formRules/plan";
import { ops } from "@/utils/scrollIndialog";
import storage from "@/utils/storage";
import { requiredItem } from "@/assets/js/formRules";
import yioksStorage from "@/assets/js/yioksStorage";
export default {
  name: "index",
//  mixins: [rulesMixin],
  props: {
    addPlan: {
      type: Boolean,
      required: true,
    },
    isEdit: {
      type: Boolean,
      default: false,
    },
    plan: {
      type: Object,
      required: false,
    },
    defaultSelect: {
      type: Object,
      required: false,
    },
  },
  data() {

    return {
      requiredItem,
      ops,
      planInfo: {
        squadUuidForCoach: '',
        organUuid: "",
        organShortName: "",
        youthShortName: "",
        youthUuid: "",
        squadUuid: "",
        trainYear: "",
        yearTrainingTask: "",
        trainAndMatchTarget: "",
        trainIdeology: "",
        trainingStageDivision: "",
        trainingArrangement: "",
        trainMeans: "",
        testArrangement: "",
        trainImplement: "",
        problemsAndDifficulties: "",
        summaryYear: "",
        uuid:''
      },
      addBtnLoading: false,
      userRole: storage.get("userInfo").userRole,
      uuid: storage.get("userInfo").uuid,
      organList: [],
      centerList: [],
      squadList: [],
      selectsquadList: [],
      editableList: [],
      suggestionList: [], // 建议列表
      days:7,
      marks: {
        // silder ,拖动滑块组件的标记
        20: "20",
        40: "40",
        60: "60",
        80: "80",
      },
    };
  },
  computed: {

    isShow: {
      get() {
        return this.addPlan;
      },
      set(val) {
        this.$emit("update:addPlan", val);
      },
    },
  },
  watch: {
  },

  created() {
    if (this.userRole === "coach") {
      this.getSquadList();
    }


  },

  methods: {

    // 回显数据
    async setPlanInfoInEditForCoach() {
      // 构造下拉选择框回显值
      const squadUuidForCoach = JSON.stringify({
        squadUuid: this.plan.squadUuid,
        youthUuid: this.plan.youthUuid,
        organUuid: this.plan.organUuid,
        organShortName: this.plan.organShortName,
        youthShortName: this.plan.youthShortName,
        shortName: this.plan.shortName,
        chiefCoachName: this.plan.chiefCoachName,
        chiefCoachUuid: this.plan.chiefCoachUuid,
      });

      // 数据回显赋值
      this.planInfo = Object.assign({}, this.plan,{
        squadUuidForCoach
      });
    },

    // 教练角色获取球队
    getSquadList() {
      const _ = require("lodash");
      squad
        .getSquadListCoachAll()
        .then((res) => {
          if (res.code) {
            this.$message.error(res.msg);
            return;
          }
          const uni_selectYouthList = _.unionBy(res, "squadUuid");
          this.selectsquadList = uni_selectYouthList.map((item) => ({
            label: `${item.organShortName} - ${item.youthShortName} - ${item.shortName}`,
            value: item.squadUuid,
            key: JSON.stringify({
              squadUuid: item.squadUuid,
              youthUuid: item.youthUuid,
              organUuid: item.organUuid,
              organShortName: item.organShortName,
              youthShortName: item.youthShortName,
              shortName: item.shortName,
              chiefCoachName: item.chiefCoachName,
              chiefCoachUuid: item.chiefCoachUuid,
            }),
            squadDissolve:item.squadDissolve,
          }));

          if (this.isEdit) {
            this.setPlanInfoInEditForCoach();
          }
        })
        .catch((err) => {
          console.error("err", err);
        });
    },


    changeSquadForCoach(val) {
      if (val) {
        const {
          organShortName,
          organUuid,
          shortName,
          squadUuid,
          youthShortName,
          youthUuid,
          chiefCoachName,
          chiefCoachUuid,
        } = JSON.parse(val);
        this.planInfo.organShortName = organShortName;
        this.planInfo.organUuid = organUuid;
        this.planInfo.shortName = shortName;
        this.planInfo.squadUuid = squadUuid;
        this.planInfo.youthShortName = youthShortName;
        this.planInfo.youthUuid = youthUuid;
        this.planInfo.chiefCoachName = chiefCoachName;
        this.planInfo.chiefCoachUuid = chiefCoachUuid;
      }
    },
    addPlanAccount() {
      this.$refs["planInfo"].validate(async (vali) => {
        if (vali) {
          this.addBtnLoading = true;
          let requestName = plan.addPlanYear;



          const { ...planForm } = this.planInfo;

          if (this.isEdit) {
            requestName = plan.updatePlanYear;
            planForm.uuid = this.planInfo.uuid;
          }

          requestName(planForm)
            .then((res) => {
              this.addBtnLoading = false;
              if (res.code) {
                this.$message.error(res.msg);
              } else {
                this.$emit("hideDialog", false);
              }
            })
            .catch((err) => {
              this.addBtnLoading = false;
              console.error(err);
            });
        }
      });
    }
  },
};
</script>

<style scoped lang="stylus">

.demo-ruleForm
  height 500px
.tip
  margin-top 10px
  color red
  width 100%
  text-align center
  word-break break-word
.plan-list-wrapper
  width 95%
  display flex
  justify-content space-around
  //border-bottom 1px dashed #ccc
  border-top 1px dashed #ccc
  padding 20px 20px 0px 0px
  margin-bottom 20px
  .left-box
    width 100%
  .right-box
    width 40px
    display flex
    justify-content center
    flex-direction column
    align-items center
  .rest
    margin-top 12px
    margin-left 12px

 .time
  position absolute
  font-size 16px
  right 0px
  top 0px

</style>
<style lang="stylus">
.yioks_alert{
  .el-slider__marks-text{
    color: #000 !important;
    margin-top: 10px;
  }
}
</style>
